import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const createPendingTextToSubscribeRecordSchema = {
  name: "createPendingTextToSubscribeRecord" as const,
  input: z.object({
    formId: z.string(),
    treatmentId: zExt.objectId().nullish(),
    anonymousId: z.string(),
  }),
  output: z.object({ lookupId: z.string() }),
};
